<template>

    <div> UNUSED!</div>
    <!--    <div class="portfolio-coordinator">-->
<!--        <design-2021-apprentice-multistep-form-wizard-form-header-component title="Coördinatoren"-->
<!--                                                                            :description="description">-->
<!--        </design-2021-apprentice-multistep-form-wizard-form-header-component>-->

<!--        <b-form-group class="portfolio-coordinators-group"-->
<!--                      label="Coördinatoren toevoegen"-->
<!--                      label-for="settings-coordinators-multi-select">-->
<!--            <design-2021-apprentice-multiselect-component class="apprentice-primary-select coordinators-selects"-->
<!--                                                          id="settings-coordinators-multi-select"-->
<!--                                                          ref="teachersMultiSelect"-->
<!--                                                          :multiple-select="true"-->
<!--                                                          track-by="id"-->
<!--                                                          label="full_name"-->
<!--                                                          :options="teachers"-->
<!--                                                          v-model="selectedTeachers"-->
<!--                                                          :allow-empty="true"-->
<!--                                                          @input="updateTeachers">-->
<!--            </design-2021-apprentice-multiselect-component>-->
<!--        </b-form-group>-->
<!--    </div>-->


</template>

<script>
import Design2021ApprenticeMultiselectComponent
    from "../../../../common/design-2021-apprentice-multiselect-component.vue";

export default {
    name: "design-2021-apprentice-portfolio-wizard-third-step-component",
    components: {Design2021ApprenticeMultiselectComponent},
    props: {
        value: Array,
        teachersIn: {
            type: Array,
            required: true,
        }
    },
    data() {
        return {
            description: 'Zoek en voeg de coördinatoren toe, die deze project gaan beheren.',
            teachers: this.teachersIn,
            selectedTeachers: [],
        }
    },
    methods:{
        updateTeachers() {
            this.$emit('input', this.selectedTeachers);
        }
    }
}
</script>

<style scoped lang="scss">
    .coordinators-selects {
        padding: 0;
    }
</style>
